module.exports = __webpack_public_path__ + "static/media/22-5.f0a26c54.mp3";